import bullebleue from './bullebleue';
import jimjoe from './jimjoe';
import santevet from './santevet';

export default {
  bullebleue,
  jimjoe,
  santevet,
};
